import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { API_URL, resolveImageUrl } from '../config';
import './CategorySection.css';



const defaultCategories = [
  {
    id: 1,
    name: 'Almonds',
    hindiName: 'Badam',
    image: 'https://images.unsplash.com/photo-1508061253366-f7da158b6d46?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 2,
    name: 'Cashews',
    hindiName: 'Kaju',
    image: 'https://images.unsplash.com/photo-1600002415506-dd0609260c18?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 3,
    name: 'Walnuts',
    hindiName: 'Akhrot',
    image: 'https://images.unsplash.com/photo-1601004890684-d8cbf643f5f2?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 4,
    name: 'Pistachios',
    hindiName: 'Pista',
    image: 'https://images.unsplash.com/photo-1543362906-acfc16c67564?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 5,
    name: 'Makhana',
    hindiName: 'Makhana',
    image: 'https://images.unsplash.com/photo-1596547609652-9cf5d8d76921?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 6,
    name: 'Raisins',
    hindiName: 'Kishmish',
    image: 'https://images.unsplash.com/photo-1568254183919-78a4f43a2877?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 7,
    name: 'Seeds & Others',
    hindiName: 'Beej',
    image: 'https://images.unsplash.com/photo-1596701062351-8c2c14d1fdd0?auto=format&fit=crop&q=80&w=300'
  },
  {
    id: 8,
    name: 'Combo Packs',
    hindiName: 'Combo',
    image: 'https://images.unsplash.com/photo-1608686207856-001b95cf60ca?auto=format&fit=crop&q=80&w=300'
  }
];

const CategorySection = () => {
  const [categories, setCategories] = useState(defaultCategories);

  useEffect(() => {
    fetch(`${API_URL}/settings/categories`)
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load categories');
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setCategories(data);
        }
      })
      .catch((err) => console.error('Error fetching categories:', err));
  }, []);

  return (
    <section id="shop-by-category" className="section-wrapper">
      <div className="container">
        {/* Header */}
        <div className="section-header">
          <div className="section-title-wrapper">
            <h2 className="section-title">Shop By Category</h2>
            <div className="title-divider" />
          </div>
          <a href="#all-categories" className="view-all-btn">
            <span>View All Categories</span>
            <ArrowRight size={14} />
          </a>
        </div>

        {/* Categories Grid */}
        <div className="category-grid">
          {categories.map((category) => (
            <Link key={category.id} to={`/category/${category.name}`} className="category-card">
              <div className="category-image-container">
                <img 
                  src={resolveImageUrl(category.image)} 
                  alt={category.name} 
                  loading="lazy" 
                />
              </div>
              <span className="category-name">{category.name}</span>
              <span className="category-hindi">({category.hindiName})</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
